export const baseUrl = 'https://fc-photogrammetry.knowledge.gr/api/';
export const projectUrl = baseUrl + 'project/';
export const authUrl = baseUrl + 'auth/login';
export const userUrl = baseUrl + 'users';
export const uploadUrl = baseUrl + 'upload';
export const pixelsUrl = baseUrl + 'pixels';
export const exportUrl = baseUrl + 'export3d';
export const categoryUrl = baseUrl + 'category';
